// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-return[data-v-4c07273d]{margin-bottom:32px;padding:0 16px;position:relative}.review-return[data-v-4c07273d]:after{background:#edeef1;content:\"\";height:1px;left:50%;position:absolute;top:70px;transform:translateX(-50%);width:320px}.review-return__link-block-btn[data-v-4c07273d]{margin-bottom:80px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
